import React, { useState } from 'react';

console.log('🔄 ORG-PICKER: Component loaded');

const OrgPicker = ({ organizations, emailAddress, onSelect, onBack, loading, error }) => {
  console.log('🔍 ORG-PICKER: Rendering with organizations:', organizations);

  // Track which org row is being signed into so only that row shows a spinner
  const [selectedOrgId, setSelectedOrgId] = useState(null);

  if (!Array.isArray(organizations) || organizations.length === 0) {
    console.error('OrgPicker: organizations prop must be a non-empty array');
    return null;
  }

  const handleSelect = (organizationId) => {
    if (loading) return;
    setSelectedOrgId(organizationId);
    onSelect(organizationId);
  };

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text-primary mb-2">LUMOZ AI</h1>
          <p className="text-text-secondary">Choose your organization</p>
        </div>

        {/* Org list card */}
        <div className="bg-background-secondary border border-accent-lavender/30 rounded-lg p-6">
          {emailAddress && (
            <p className="text-text-muted text-sm mb-4">
              Signed in as <span className="text-text-secondary">{emailAddress}</span>
            </p>
          )}

          {error && (
            <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded">
              <p className="text-red-400 text-sm font-medium">
                {typeof error === 'string' ? error : String(error)}
              </p>
            </div>
          )}

          <div className="space-y-2">
            {organizations.map((org) => {
              const organization = org.organization;
              const orgId = organization?.organization_id;
              const orgName = organization?.organization_name || 'Organization';
              const isSigningIn = loading && selectedOrgId === orgId;

              return (
                <button
                  key={orgId}
                  onClick={() => handleSelect(orgId)}
                  disabled={loading}
                  className="w-full flex items-center justify-between px-4 py-3 bg-background-primary border border-border-subtle rounded-lg text-left hover:border-accent-primary-base/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span className="flex items-center space-x-3 min-w-0">
                    <span className="text-xl flex-shrink-0">🏢</span>
                    <span className="text-text-primary font-medium truncate">{orgName}</span>
                  </span>
                  <span className="text-text-muted flex-shrink-0 ml-3">
                    {isSigningIn ? 'Signing in…' : '→'}
                  </span>
                </button>
              );
            })}
          </div>

          {onBack && (
            <button
              onClick={onBack}
              disabled={loading}
              className="mt-6 text-text-muted text-sm hover:text-text-secondary transition-colors disabled:opacity-50"
            >
              Use a different email
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrgPicker;
